export enum FormType {
  CREATE = "CREATE",
  EDIT = "EDIT",
}
